import { CentralSessionControls, SessionControl, SessionControlsLayout } from '../../../components';
import { ToolbarSeparator } from '../../../components/ToolbarSeparator';
import { useObscuredVisitorContentProps } from '../../a11y';
import { VisitorAdditionalOptionsMenuWrapper as VisitorAdditionalOptionsMenu } from '../../controls/VisitorAdditionalOptionsMenuWrapper';
import { VisitorAudioControlWrapper as VisitorAudioControl } from '../../controls/VisitorAudioControlWrapper';
import { VisitorVideoControlWrapper as VisitorVideoControl } from '../../controls/VisitorVideoControlWrapper';
import {
  VisitorWaitingChatDrawerButtonWrapper as VisitorWaitingChatDrawerButton,
  VisitorWaitingChatDrawerMenuItemWrapper as VisitorWaitingChatDrawerMenuItem,
} from './VisitorWaitingChatDrawerControlWrapper';
import {
  VisitorWaitingMeasureDrawerControlButton,
  VisitorWaitingMeasureDrawerControlMenuItem,
} from './VisitorWaitingMeasureDrawerControl';
import {
  VisitorWaitingReflectionTopicsDrawerControlButton,
  VisitorWaitingReflectionTopicsDrawerControlMenuItem,
} from './VisitorWaitingReflectionTopicsDrawerControl';
import {
  VisitorWaitingSettingsControlButton,
  VisitorWaitingSettingsDrawerControlMenuItem,
} from './VisitorWaitingSettingsDrawerControl';

const centralControls: SessionControl[] = [
  {
    key: 'audio',
    toolbarComponent: VisitorAudioControl,
  },
  {
    key: 'video',
    toolbarComponent: VisitorVideoControl,
  },
  {
    key: 'av-separator',
    toolbarComponent: ToolbarSeparator,
  },
  {
    key: 'chat',
    toolbarComponent: VisitorWaitingChatDrawerButton,
    additionalOptionsMenuItemComponent: VisitorWaitingChatDrawerMenuItem,
  },
  {
    key: 'reflection-topics',
    toolbarComponent: VisitorWaitingReflectionTopicsDrawerControlButton,
    additionalOptionsMenuItemComponent: VisitorWaitingReflectionTopicsDrawerControlMenuItem,
  },
  {
    key: 'measures',
    toolbarComponent: VisitorWaitingMeasureDrawerControlButton,
    additionalOptionsMenuItemComponent: VisitorWaitingMeasureDrawerControlMenuItem,
  },
  {
    key: 'settings',
    toolbarComponent: VisitorWaitingSettingsControlButton,
    additionalOptionsMenuItemComponent: VisitorWaitingSettingsDrawerControlMenuItem,
  },
];

export function VisitorWaitingSessionControlsWrapper() {
  const obscuredContentProps = useObscuredVisitorContentProps();

  return (
    <SessionControlsLayout {...obscuredContentProps} className='order-3'>
      <CentralSessionControls
        controls={centralControls}
        additionalOptionsMenuComponent={VisitorAdditionalOptionsMenu}
      />
    </SessionControlsLayout>
  );
}
